import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "./BaseUrl";
import BatchEdit from "./BatchEdit";
import InnerHeader from "./InnerHeader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link, useNavigate } from "react-router-dom";
import { StyledDataGrid } from "./StyledDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import { cond } from "lodash";
import { create } from "js-md5";
import decryptedUserId from "../Utils/UserID";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Convocation = () => {

  const [open, setOpen] = React.useState(false);
  const { batchid } = useParams();
  const [cid, setCid] = useState("")
  const [faculty, setFaculty] = useState([])
  const [uid, setUid] = useState([])
  const navigate = useNavigate()


  const [value, setValue] = useState({
    faculty: "",
    guest_name: "",
    guest_mobile: "",
    email: "",
    guest_designation: "",
    convocation_date: "",
    convocation_day: ""
  });


  async function getFacultySalaryReport() {
    try {
      const response = await axios.get(`${BASE_URL}/getfaculty_masterdata`, {
        headers: {
          "Content-Type": "application/json",
        }
      });

      setFaculty(response.data);

    } catch (error) {
      console.error("Error fetching faculty salary report:", error);

    }
  }

  useEffect(() => {
    getFacultySalaryReport();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "guest_mobile") {
      updatedValue = String(value || "").replace(/\D/g, "").slice(0, 10);
    }

    // If user selects a date, calculate day name
    if (name === "convocation_date") {
      const dayName = new Date(value).toLocaleDateString("en-US", { weekday: "long" });
      setValue((prev) => ({
        ...prev,
        convocation_date: value,
        convocation_day: dayName
      }));
      return;
    }

    setValue((prev) => ({ ...prev, [name]: updatedValue }));
  };

  const [guestList, setGuestList] = useState([]);

  // Fetch existing guests for this batch
  async function getGuestList() {
    try {
      const res = await axios.get(`${BASE_URL}/get_batchconvocation/${batchid}`);
      setGuestList(res.data);
    } catch (error) {
      console.error("Error fetching guest list:", error);
    }
  }


  async function getupdatedata() {

    const data = {
      u_id: batchid,
      uidname: "Batch_Id",
      tablename: "Batch_Mst"
    }
    axios.post(`${BASE_URL}/new_update_data`, data)
      .then((res) => {
        setValue({
          ...value,
          convocation_date: res.data[0].ConvocationDate,
          convocation_day: res.data[0].Convocationday
        });
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    getupdatedata()
    getGuestList();
  }, [batchid]);



  const roledata = {
    role: Cookies.get(`role`),
    pageid: 106,
  };

  const dispatch = useDispatch();
  const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

  useEffect(() => {
    dispatch(getRoleData(roledata));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      batch_id: batchid, // from URL params
      fname: value.faculty,
      gname: value.guest_name,
      mobile_no: value.guest_mobile,
      email_id: value.email,
      gdesig: value.guest_designation
    };

    axios.post(`${BASE_URL}/add_batchconvocation`, data)
      .then(res => {
        console.log(res.data.message);
        getGuestList();
      })
      .catch(err => {
        console.error("Error inserting:", err);
      });

  };

  const updatebatchdetails = () => {

    const data = {
      batch_id: batchid,
      convocation_date: value.convocation_date,
      convocation_day: value.convocation_day,
      created_by: decryptedUserId()

    }

    axios.post(`${BASE_URL}/update_convocationdate`, data)
      .then(res => {
        getupdatedata()
        console.log(res.data.message);
        alert("Convocation details updated successfully");
      })
      .catch(err => {
        console.error("Error inserting:", err);
      });
  };



  return (
    <div className="container-fluid page-body-wrapper ">
      <InnerHeader />
      <div className="main-pannel">
        <div className="content-wrapper ">
          <BatchEdit batchid={batchid} />
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="d-flex justify-content-between gap-3"
                    style={{ borderBottom: "2px solid #dce4ec", width: "100%", padding: "10px 0" }}
                  >
                    <div>
                      <h4 class="card-title">Convocation Details :</h4>
                    </div>

                  </div>

                  <form onSubmit={handleSubmit}>
                    <hr className="py-1" />

                    <div className="table-responsive">
                      <table className="table table-bordered table-gen">
                        <thead>
                          <tr>
                            <th>Faculty Name</th>
                            <th>Guest Name</th>
                            <th>Guest Mobile No.</th>
                            <th>Email</th>
                            <th>Guest Designation</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {guestList.map((guest, index) => (
                            <tr key={guest.Id}>
                              <td>{guest.FName}</td>
                              <td>{guest.GName}</td>
                              <td>{guest.Mobile_no}</td>
                              <td>{guest.Email_id}</td>
                              <td>{guest.GDesig}</td>
                              <td>—</td>
                            </tr>
                          ))}

                          {/* New Guest Input Row */}
                          <tr>
                            <td>
                              <select
                                className="form-control"
                                id="exampleFormControlSelect1"
                                value={value.faculty}
                                name="faculty"
                                onChange={handleChange}
                              >
                                <option value="">--Faculty Name--</option>
                                {faculty.map((item, index) => (
                                  <option key={index} value={item.Faculty_Name}>
                                    {item.Faculty_Name}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Guest Name"
                                value={value.guest_name}
                                name="guest_name"
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <input
                                type="tel"
                                maxLength={10}
                                inputMode="numeric"
                                className="form-control"
                                placeholder="10-digit Guest Mobile"
                                value={value.guest_mobile}
                                name="guest_mobile"
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                value={value.email}
                                name="email"
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Guest Designation"
                                value={value.guest_designation}
                                name="guest_designation"
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <button type="submit" className="btn btn-primary btn-sm">
                                Save
                              </button>

                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>


                  </form>

                  {/* Convocation Date & Day */}
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <label className="form-label">Convocation Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="convocation_date"
                        value={value.convocation_date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Convocation Day</label>
                      <input
                        type="text"
                        className="form-control"
                        name="convocation_day"
                        value={value.convocation_day}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary mt-4"
                        onClick={updatebatchdetails}
                      >
                        Save
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add Company Information
        </DialogTitle>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>


        </DialogContent>
        <DialogActions>

        </DialogActions>
      </BootstrapDialog>

    </div>
  );
};

export default Convocation;
